import React from 'react';
const TermsAndConditions = () => {
    return (
        <div>
            <ng-marketing-component content-code="FOWWIIV-TERMS"></ng-marketing-component>
        </div>
    );
}
export default TermsAndConditions;